const delegationRoutesUrls = {
  add: `/delegation/add`,
  listing: `/delegation/listing`,
  join: `/mileage/join`,
};

export default delegationRoutesUrls;
